import React from "react";
import { connect } from "react-redux";
import { commons, FixedDropDownButton, Icon, modal, utils } from "@mc/mc-legacy";
import GroupMenu from "../components/GroupMenu";
import CustomPageLayout from "./CustomPageLayout";
import * as actions from "../actions/odmitnuteDokumentyActions";
import * as pdfViewerActions from "../actions/pdfViewerActions";
import { Col, DropdownItem, Row } from "reactstrap";
import SignRequestTitle from "../components/SignRequestTitle";
import ShowButton from "../components/ShowButton";
import SignRequestDocumentData from "../components/SignRequestDocumentData";
import * as groupMenuActions from "../actions/groupMenuActions";
import signRequestInternalApi from "../api/gen/qsign/SignRequestInternalApi";
import * as pozadavkyActions from "../actions/pozadavkyActions";
import EnumState from "../api/gen/qsign/types/EnumState";
import MessageEmptyList from "../components/MessageEmptyList";
import "./CustomItem.scss";
import ItemListFixed from "../components/ItemListFixed";
import PrilohyButton from "../components/PrilohyButton";
const { sinkEvent } = commons;
/**
 * Odmítnuté dokumenty page.
 */

class OdmitnuteDokumenty extends React.Component {
  componentDidMount() {
    this.fetchData(this.props, true);
    this.handleFilter();
  }

  handleFilter() {
    const { filterList } = this.props;
    this.props.dispatch(pozadavkyActions.filter({ ...filterList.filter, stateList: [EnumState.REJECTED] }));
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.fetchData(nextProps, false);
  }

  handleZobrazit = (signRequest) => {
    this.props.dispatch(pdfViewerActions.showDocument(signRequest));
  };
  fetchData = (props, forceFetch) => {
    const { dispatch } = props;
    dispatch(actions.fetchIfNeeded(forceFetch));

    if (forceFetch) {
      dispatch(groupMenuActions.invalidate());
    }
  };
  handleProcessedRequestConfirm = (signRequestDocument) => {
    const { dispatch } = this.props;
    dispatch(
      modal.ModalActions.showConfirm(
        "Potvrzení zpracování",
        "Zpracovat všechny odmítnuté dokumenty tohoto požadavku?",
        () => this.handleProcessedRequest(signRequestDocument),
        null,
        "Potvrdit"
      )
    );
  };
  handleProcessedRequest = (signRequestDocument) => {
    signRequestInternalApi.processRequestByDocumentId(signRequestDocument.id).then(() => {
      this.fetchData(this.props, true);
    });
  };
  handleProcessed = (signRequestDocument) => {
    signRequestInternalApi.processRequestDocument(signRequestDocument.id).then(() => {
      this.fetchData(this.props, true);
    });
  };
  handleDownload = (signRequestDocument) => {
    console.warn(signRequestDocument);
    signRequestInternalApi.downloadRequestDocument(signRequestDocument.id).then(() => {});
  };
  renderItem = (item: SignRequestWithCountsVO) => {
    const { rejectReason } = item;
    return (
      <div className="custom-item">
        <div className="custom-item-content">
          <Row noGutters className="ml-3">
            <Col xs={12} lg={6} className="content-center">
              <SignRequestTitle
                onClick={() => this.handleZobrazit(item)}
                signRequest={item}
                icon
                customRender={(item) => {
                  if (item.attachmentCount > 0) {
                    return <PrilohyButton attachmentCount={item.attachmentCount} itemID={item.requestId} />;
                  }
                }}
              />
            </Col>
            <Col xs={12} lg={6} className="content-center">
              <SignRequestDocumentData requestDocument={item} />
            </Col>
          </Row>
        </div>
        <div className="custom-item-action">
          <div className="action-icon">
            <div className="action-icon-content simple">
              <Icon title={rejectReason} icon={"times"} color={"red"} />
            </div>
          </div>
          {this.renderActions(item)}
        </div>
      </div>
    );
  };
  renderActions = (item) => {
    return (
      <div className="actions actions-button">
        <ShowButton title="Zobrazit" onClick={() => this.handleZobrazit(item)} />
        <FixedDropDownButton
          onClick={sinkEvent}
          color="action"
          noCaret
          title={<Icon icon="ellipsis-v" className="action-ellipsis" />}
        >
          <DropdownItem target="_blank" key="0" href={moduleContextPath + `/api/signRequestDocument/${item.id}/download`}>
            Uložit dokument
          </DropdownItem>
          <DropdownItem key="1" onClick={() => this.handleProcessed(item)}>
            Zpracováno
          </DropdownItem>
          <DropdownItem key="2" onClick={() => this.handleProcessedRequestConfirm(item)}>
            Zpracovat požadavek
          </DropdownItem>
        </FixedDropDownButton>
      </div>
    );
  };

  render() {
    const { itemList } = this.props;
    const listProps = {
      itemList,
      loadMore: actions.loadMore,
      invalidatePozadavky: actions.invalidatePozadavky,
      renderItem: this.renderItem,
      emptyList: (
        <MessageEmptyList>
          <div className="message">
            Žádné dokumenty ke zpracování
            <div className="thumbup">
              <Icon icon="thumbs-o-up fa-4x" />
            </div>
          </div>
        </MessageEmptyList>
      ),
    };
    return (
      <CustomPageLayout header title="Odmítnuté dokumenty" menu={<GroupMenu />}>
        <ItemListFixed {...listProps} />
      </CustomPageLayout>
    );
  }
}

function mapStateToProps(state) {
  return {
    itemList: utils.storeFromArea(state, actions.ODMITNUTE_DOKUMENTY_LIST),
    filterList: utils.storeFromArea(state, pozadavkyActions.POZADAVKY_SEARCH_LIST),
  };
}

export default connect(mapStateToProps)(OdmitnuteDokumenty);
